export const getReportEntityName = (aiType?: string, isNoActions?: boolean, reportState?: number) => {
  const isRegularAI = aiType === 'regular';

  if (isNoActions && reportState !== 1) {
    return isRegularAI ? 'no_action_report' : 'ww_no_action_report';
  }

  return isRegularAI ? 'report' : 'ww_report';
};
